<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="chapter"><a id="page_1"></a><a id="p9000f1639970001001">
</a><p class="halftitle">THE KNITTER’S BIBLE</p><p class="book-subtitle">knitted throws and cushions</p><a id="page_2"></a><a id="p9000f1639960002001">
</a><div class="media-group"><img alt="" src="images/p9000f163g2001.png" width="90.38113%"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7fe19334